import { GroupChannel } from "@sendbird/chat/lib/__definition";

import { GROUP_CHAT_CUSTOM_TYPE } from "../constants";

export function isGroupChatChannel(channel: GroupChannel | null | undefined): boolean {
  if (!channel) {
    return false;
  }

  if (channel.customType === GROUP_CHAT_CUSTOM_TYPE) {
    return true;
  }

  const memberCount = channel.memberCount ?? channel.members?.length ?? 0;
  return !channel.isDistinct && memberCount > 2;
}
